import { render, staticRenderFns } from "./CancelOrderPopup.vue?vue&type=template&id=70e81d4a&"
import script from "./CancelOrderPopup.vue?vue&type=script&lang=js&"
export * from "./CancelOrderPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports